import styled from "@emotion/styled";
import XDiv from "../../core/XDiv";
import { MAIN_COLOR } from "../../../utils/constants/common/utils";

const XGUIContainer = styled(XDiv)<{ width?: string }>`
  width: 400px;
  height: 100%;
  position: relative;
  z-index: 100;
  transition: all linear 0.3s;

  & .XGUI-Header {
    flex-direction: row;
    background-color: ${MAIN_COLOR};
    width: 100%;
    color: white;
    min-height: 50px;
    display: flex;
    align-items: center;
    gap: 10px;
    /* margin-bottom: 15px; */
    /* border-radius: 0px; */
    /* overflow: hidden; */
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.75);

    & .XGUI-Drag-Handler {
      width: 50px;
      height: 100%;
      background-color: black;
      font-size: 20px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      text-align: center;
      border: none;
      display: flex;
    }

    & .XGUI-Header-Breadcrumb {
      height: 100%;
      align-items: center;
      flex-direction: row;
      flex: 1;
      gap: 5px;
      cursor: default;
      font-size: 10px;

      & .XGUI-Header-Breadcrumb-Path {
        font-size: 10px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 700;
        background-color: transparent;
        color: white;
        padding: 0;
        border: none;
      }
    }

    & .XGUI-Header-Btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.2);
      font-size: 20px;
      color: white;
      border: 0;
      cursor: pointer;
      transition: linear all 0.2s;

      &:hover {
        background-color: #000000;
      }
    }
  }

  & .XGUI-Fields-Container {
    /* background-color: #101122; */
    background-color: #0e0d18;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.75);
    position: relative;
    color: black;
    flex: 1;

    & .XGUI-Fields-Tabs {
      background-color: #000000;
      flex-direction: row;

      & .XGUI-Fields-Tab {
        height: 40px;
        flex: 1;
        border: 0;
        background-color: transparent;
        font-size: 10px;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.5);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 5px;

        &.XGUI-Tab-Active {
          font-weight: 700;
          color: white;
          background-color: #101122;
        }
      }
    }

    & .XGUI-Fields-List {
      padding: 0 15px;
      gap: 10px;
      overflow-y: scroll;
      overflow-x: hidden;
      transition: all linear 0.3s;
      height: 100%;

      /* & .MuiAccordionDetails-root > div:hover {
        background-color: rgba(255, 255, 255, 0.1);
      } */

      /* &:not(.hasPage) { */
      /* min-height: 200px;
      max-height: 380px; */
      /* } */

      /* &.hasPage {
        max-height: calc(100vh - 400px);
        /* height: calc(100vh - 400px); */
      /* top: 0; */
      /* right: 0; */
      /* } */

      & .XGUI-Field {
        position: relative;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        line-height: 1em;

        &:not(:last-of-type) {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          padding-bottom: 15px;
        }

        & .XGUI-Field-Label {
          color: white;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-size: 9px;
          font-weight: 600;
          width: 30%;
          text-align: left;
          margin-right: 10px;
          line-height: 1.5em;
        }

        & .XGUI-Field-Control {
          flex: 1;
          flex-direction: row;
          border-radius: 0px;

          &:has(.Addon-Right:focus),
          &:has(.With-Addon-Right:focus) {
            outline: 2px solid rgba(255, 255, 255, 0.5);
          }
        }

        & .XGUI-Field-Input,
        & .XGUI-Field-Select {
          box-sizing: border-box;
          border: 0;
          background-color: #3a394b;
          color: white;
          border-radius: 0px;
          padding: 5px 8px;
          height: 32px;

          &:focus {
            outline: 2px solid rgba(255, 255, 255, 0.5);
          }
        }

        & .XGUI-Field-Select {
          border-right: 8px solid #3a394b;
        }

        & .With-Addon-Right {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          &:focus {
            outline: none;
          }
        }

        & .Addon-Right {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          padding-left: 0;

          &:focus {
            outline: none;
          }
        }

        & .XGUI-Field-ColorPicker-Btn {
          width: 32px;
          height: 32px;
          box-sizing: border-box;
          border: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 0px;
          margin-left: 5px;
        }

        & .XGUI-Field-ColorPicker-Modal {
          position: absolute;
          width: 220px;
          top: 37px;
          right: 0;
          background-color: #fff;
          padding: 10px;
          border-radius: 10px;
          box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.25);
          z-index: 101;
        }
      }
    }
  }

  &[data-popper-placement="top"] {
    flex-direction: column-reverse;

    & .XGUI-Header {
      margin-top: 10px;
      margin-bottom: 0;
    }
  }
`;

export default XGUIContainer;
